'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var fillSegment = function fillSegment() {
  var segment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


  if (typeof segment === 'string') {
    segment = { direction: segment, size: '100%' };
  }

  return {
    direction: segment.direction ? segment.direction : 'top',
    size: segment.size ? segment.size : '100%'
  };
};

var initTranslateProp = function initTranslateProp(translate) {

  if (typeof translate === 'boolean') {
    translate = { enter: 'top', exit: 'top' };
  } else if (typeof translate === 'string') {
    translate = { enter: translate, exit: translate };
  } else if ((typeof translate === 'undefined' ? 'undefined' : _typeof(translate)) !== 'object') {
    translate = {};
  }

  return {
    enter: fillSegment(translate.enter),
    exit: fillSegment(translate.exit),
    useSameTransition: !!translate.useSameTransition
  };
};

exports.default = initTranslateProp;